import { j as t, c as o } from "./utils-BdNIfrGQ.js";
import { R as l, C as r, a as s, T as d, b as g, P as c, O as u, D as f } from "./index-DMKTT9GV.js";
import { X as x } from "./x-BXShoIAM.js";
function h({
  ...a
}) {
  return /* @__PURE__ */ t.jsx(l, { "data-slot": "dialog", ...a });
}
function v({
  ...a
}) {
  return /* @__PURE__ */ t.jsx(g, { "data-slot": "dialog-trigger", ...a });
}
function m({
  ...a
}) {
  return /* @__PURE__ */ t.jsx(c, { "data-slot": "dialog-portal", ...a });
}
function y({
  ...a
}) {
  return /* @__PURE__ */ t.jsx(s, { "data-slot": "dialog-close", ...a });
}
function p({
  className: a,
  ...e
}) {
  return /* @__PURE__ */ t.jsx(
    u,
    {
      "data-slot": "dialog-overlay",
      className: o(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
        a
      ),
      ...e
    }
  );
}
function N({
  className: a,
  children: e,
  showCloseButton: n = !0,
  ...i
}) {
  return /* @__PURE__ */ t.jsxs(m, { "data-slot": "dialog-portal", children: [
    /* @__PURE__ */ t.jsx(p, {}),
    /* @__PURE__ */ t.jsxs(
      r,
      {
        "data-slot": "dialog-content",
        className: o(
          "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full sm:max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 sm:rounded-lg border p-6 shadow-lg duration-200",
          a
        ),
        ...i,
        children: [
          e,
          n && /* @__PURE__ */ t.jsxs(
            s,
            {
              "data-slot": "dialog-close",
              className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-5 right-6 rounded-lg opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-6",
              children: [
                /* @__PURE__ */ t.jsx(x, { size: 16, strokeWidth: 2 }),
                /* @__PURE__ */ t.jsx("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ]
      }
    )
  ] });
}
function z({ className: a, ...e }) {
  return /* @__PURE__ */ t.jsx(
    "div",
    {
      "data-slot": "dialog-header",
      className: o("flex flex-col gap-2 text-left", a),
      ...e
    }
  );
}
function C({ className: a, ...e }) {
  return /* @__PURE__ */ t.jsx(
    "div",
    {
      "data-slot": "dialog-footer",
      className: o("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", a),
      ...e
    }
  );
}
function k({
  className: a,
  ...e
}) {
  return /* @__PURE__ */ t.jsx(
    d,
    {
      "data-slot": "dialog-title",
      className: o("text-lg leading-none font-semibold", a),
      ...e
    }
  );
}
function T({
  className: a,
  ...e
}) {
  return /* @__PURE__ */ t.jsx(
    f,
    {
      "data-slot": "dialog-description",
      className: o("text-muted-foreground text-sm", a),
      ...e
    }
  );
}
export {
  h as D,
  v as a,
  m as b,
  p as c,
  N as d,
  z as e,
  k as f,
  T as g,
  C as h,
  y as i
};
